var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "button",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isAutoOpened,
            expression: "!isAutoOpened",
          },
        ],
        class: _vm.buttonClass,
        attrs: {
          type: "button",
          "data-bs-toggle": "modal",
          "data-bs-target": "#" + _vm.id,
          "data-oevent-category": _vm.actionTms.category,
          "data-oevent-action": _vm.actionTms.action,
          "data-oevent-label": _vm.actionTms.label,
          "aria-label": _vm.ariaLabel,
        },
      },
      [
        _vm.isIconButton
          ? _c("span", {
              staticClass: "icon",
              class: _vm.iconName,
              attrs: { "aria-hidden": "true" },
            })
          : [_vm._v("\n            " + _vm._s(_vm.actionLabel) + "\n        ")],
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: _vm.id,
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": _vm.labelId,
          "aria-hidden": "true",
          "data-ob1-component": "Popin",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": _vm.modalCloseLabel,
                    },
                  },
                  [
                    _c("span", {
                      staticClass: "icon icon-delete",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.imageUrl
                ? _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "ob1-modal-body-visual" }, [
                      _c("div", { staticClass: "ob1-modal-img" }, [
                        _c("img", { attrs: { src: _vm.imageUrl, alt: "" } }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ob1-modal-content" }, [
                        _vm.modalTitle
                          ? _c("h4", {
                              attrs: { id: _vm.labelId },
                              domProps: { innerHTML: _vm._s(_vm.modalTitle) },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.modalContent) +
                              "\n                            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ob1-modal-footer-visual" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary m-0",
                              attrs: { type: "button" },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.modalButtonLabel) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _c("div", { staticClass: "modal-body" }, [
                    _vm.modalTitle
                      ? _c("h4", {
                          attrs: { id: _vm.labelId },
                          domProps: { innerHTML: _vm._s(_vm.modalTitle) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.modalContent
                      ? _c("p", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.modalContent) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.alertHtmlContent
                      ? _c("div", {
                          staticClass:
                            "alert-container additional-message align-items-center",
                          domProps: { innerHTML: _vm._s(_vm.alertHtmlContent) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.htmlContent
                      ? _c("div", {
                          staticClass: "mt-1",
                          domProps: { innerHTML: _vm._s(_vm.htmlContent) },
                        })
                      : _vm._e(),
                  ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "modal-footer d-inline-flex flex-column flex-md-row-reverse justify-content-center",
                },
                [
                  _vm.isModalButtonPrimary
                    ? _c(
                        "button",
                        _vm._b(
                          {
                            staticClass:
                              "btn btn-primary mx-0 mb-2 ms-md-2 mb-md-0",
                            attrs: { type: "button" },
                          },
                          "button",
                          _vm.isModalButtonClose
                            ? { "data-bs-dismiss": "modal" }
                            : {},
                          false
                        ),
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.modalButtonLabel) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _c(
                        "button",
                        _vm._b(
                          {
                            staticClass: "btn btn-secondary m-0",
                            attrs: { type: "button" },
                          },
                          "button",
                          _vm.isModalButtonClose
                            ? { "data-bs-dismiss": "modal" }
                            : {},
                          false
                        ),
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.modalButtonLabel) +
                              "\n                    "
                          ),
                        ]
                      ),
                ]
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }